import { TRARecentFormBars } from "../../../design";

/**
 * Rankings adapter — delegates to canonical `TRARecentFormBars`.
 * Prefer importing `TRARecentFormBars` directly on new screens.
 */
export default function RecentFormStrip({ form, letters, limit = 5, caption, padEmpty = true, empty }) {
  return (
    <TRARecentFormBars
      form={form}
      letters={letters}
      limit={limit}
      caption={caption}
      padEmpty={padEmpty}
      empty={empty}
    />
  );
}
